import React from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import {
  getFormattedDate,
  getUTCDateFromMilliseconds,
} from '../utils/smartutils';

const EventHeaderCard = ({ t, eventHeader }) => {
  return (
    <div className="event-header-card">
      {eventHeader.local && (
        <div>
          <span>{t('general.local')}&#58;</span>
          <span>{eventHeader.local}</span>
        </div>
      )}
      {eventHeader.allDay ? (
        <>
          <div>
            <span>{t('general.initial')}&#58;</span>
            <span>
              {`${getFormattedDate(
                getUTCDateFromMilliseconds(eventHeader.initialDate) ||
                  new Date()
              )} - ${t('general.all-day')}`}
            </span>
          </div>
          <div>
            <span>{t('general.termination')}&#58;</span>
            <span>
              {`${getFormattedDate(
                getUTCDateFromMilliseconds(eventHeader.finalDate) || new Date()
              )} - ${t('general.all-day')}`}
            </span>
          </div>
        </>
      ) : (
        <>
          <div>
            <span>{t('general.initial')}&#58;</span>
            <span>
              {`${getFormattedDate(
                getUTCDateFromMilliseconds(eventHeader.initialDate) ||
                  new Date()
              )}
              - ${eventHeader.initialHour}`}
            </span>
          </div>
          <div>
            <span>{t('general.termination')}&#58;</span>
            <span>
              {`${getFormattedDate(
                getUTCDateFromMilliseconds(eventHeader.finalDate) || new Date()
              )}
              - ${eventHeader.finalHour}`}
            </span>
          </div>
        </>
      )}
    </div>
  );
};
EventHeaderCard.propTypes = {
  t: PropTypes.func.isRequired,
  eventHeader: {
    allDay: PropTypes.bool,
    local: PropTypes.string,
    initialDate: PropTypes.number,
    finalDate: PropTypes.number,
    initialHour: PropTypes.string,
    finalHour: PropTypes.string,
  }.isRequired,
};

export default withTranslation('common')(EventHeaderCard);
